var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProformaInvoicesReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M28.6 37.6h-15c-3.1 0-5.7-2.5-5.7-5.7V10.8c0-3.1 2.5-5.7 5.7-5.7h15.2c3.1 0 5.7 2.5 5.7 5.7v21.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M13.7 23.6h14.6M13.7 29.8h14.6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 13.7,
    cy: 12.8,
    r: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M22.5 15.8l-3.1-2.9 3-3.1M20.4 12.8h7.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProformaInvoicesReceived);
export default __webpack_public_path__ + "static/media/proformaInvoicesReceived.c14f517d863d88b72760b33520da12f4.svg";
export { ForwardRef as ReactComponent };